import { render, staticRenderFns } from "./serveDetails.vue?vue&type=template&id=13884fe8&scoped=true"
import script from "./serveDetails.vue?vue&type=script&lang=js"
export * from "./serveDetails.vue?vue&type=script&lang=js"
import style0 from "./serveDetails.vue?vue&type=style&index=0&id=13884fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13884fe8",
  null
  
)

export default component.exports